import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import s from './TextAreaEditor.module.scss';

export default class TextAreaEditor extends Component {
    static propTypes = {
        big: PropTypes.bool,
        className: PropTypes.string,
        disabled: PropTypes.bool,
        invalid: PropTypes.bool,
        label: PropTypes.string,
        onChange: PropTypes.func,
        placeHolder: PropTypes.string,
        value: PropTypes.string,
    };

    static defaultProps = {
        big: false,
        className: '',
        disabled: false,
        invalid: false,
        label: '',
        onChange: () => {},
        placeHolder: '',
        value: '',
    };

    handleTextChange = event => {
        const { value } = event.target;
        this.props.onChange(value);
    };

    render() {
        const { className, placeHolder, label, value, disabled, big, invalid } = this.props;

        return (
            <div className={classNames(className, s.textAreaEditor, { [s.big]: big })}>
                <div className={s.label}>{label.toUpperCase()}</div>
                <textarea
                    ref={input => {
                        this.textInput = input;
                    }}
                    value={value || ''}
                    placeholder={placeHolder}
                    onChange={this.handleTextChange}
                    disabled={disabled}
                    className={classNames({ [s.invalid]: invalid })}
                    data-testid={'text-area'}
                />
            </div>
        );
    }
}
